<template>
  <div class="login register">
    <div class="login-box">
      <router-link to="/"><img src="/static/images/login-logo.png" class="logo"></router-link>
    </div>
    <van-cell-group>
      <div class="van-cell van-hairline van-field van-field--has-icon">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-shoujihao"></i></div>-->
        <i class="van-icon iconfont icon-shoujihao inputlabel"></i>
        <div class="van-cell__value">
          <input type="number" placeholder="请输入手机号" v-model="mobile" class="van-field__control">
        </div>
      </div>
      <div class="van-cell van-hairline van-field van-field--has-icon">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-yonghuming"></i></div>-->
        <i class="van-icon iconfont icon-yonghuming inputlabel"></i>
        <div class="van-cell__value">
          <input type="text" placeholder="请输入昵称" v-model="name" class="van-field__control">
        </div>
      </div>

      <div class="van-cell van-hairline van-field van-field--has-icon">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-mima"></i></div>-->
        <i class="van-icon iconfont icon-mima inputlabel"></i>
        <div class="van-cell__value">
          <input type="password" placeholder="请输入密码" v-model="password" class="van-field__control">
        </div>
      </div>
      <div class="van-cell van-hairline van-field van-field--has-icon">
        <!--<div class="van-cell__title"><i class="van-icon iconfont icon-mima"></i></div>-->
        <i class="van-icon iconfont icon-mima inputlabel"></i>
        <div class="van-cell__value">
          <input type="password" placeholder="确认密码" v-model="repassword" class="van-field__control">
        </div>
      </div>
      <div style="overflow: hidden">
        <div style="width: 60%;float: left;padding: 4px 15px 5px 15px" class="codebox van-cell van-hairline van-field van-field--has-icon">
          <!--<div class="van-cell__title"><i class="van-icon iconfont icon-yanzhengma"></i><span>验证码</span></div>-->
          <i class="van-icon iconfont icon-yanzhengma inputlabel" style="margin-top: 8px"></i>
          <div class="van-cell__value"><input type="number" placeholder="请输入验证码" v-model="code" class="van-field__control"></div>
        </div>
        <div  class="van-field__button">
          <van-button slot="button" size="small" @click="getCode()" class="theme-bg" :loading="codeLoading">获取验证码</van-button>
        </div>
      </div>

      <van-cell>
        <van-button size="large" class="theme-bg loginbtn" @click="senData()" :loading="loading">注册</van-button>
        <router-link to="/login" tag="div" class="text-cent">已有账号？<span class="theme-col">立即登录</span></router-link>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  export default {
    name: "index",
    data () {
      return {
        loading:false,
        codeLoading:false,
        mobile:'',
        code:'',
        name:'',
        password:'',
        repassword:'',
        share_id:this.$route.query.share_id == undefined?'0':this.$route.query.share_id,
        source:this.$route.query.source == undefined?'0':this.$route.query.source
      }
    },
    methods: {
      goLogin: function () {
        this.$router.push({ name: 'Login' })
      },
      getCode: function () {
        var _this = this
        var reg = /^[1][0-9][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.codeLoading = true
          this.$api.post('WebApi/Login/Register/sendMmsCode', {mobile:this.mobile}, res => {
            if(res.data.errCode == '0000'){
              this.$toast("发送成功请注意查收");
              var time = 60
              var dd = setInterval(function () {
                time--
                $(".register .codebox .van-button").html(time+' s')
                if(time <= 0){
                  clearInterval(dd)
                  _this.codeLoading = false
                  $(".register .codebox .van-button").html('<span class=\\"van-button__text\\">重新发送</span>')
                }
              },1000)
            }else {
              this.$toast(res.data.desc);
              _this.codeLoading = false
            }
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
      senData: function () {
        var _this = this
        var reg = /^[1][0-9][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.loading = true
          this.$api.post('WebApi/Login/Register/creat', {share_id:this.share_id,source:this.source,mobile:this.mobile,name:this.name,password:this.password,repassword:this.repassword,mms_code:this.code}, res => {
            if(res.data.errCode == '0000'){
              this.$dialog.confirm({
                title:'提示',
                message: '注册成功是否立即登录？'
              }).then(() => {
                this.$router.push({path:'/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.desc);
            }
            this.loading = false
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
      loginMode: function () {
        var logintype = localStorage.getItem("BLHlogintype");
        if(logintype == 1){
          if(this.$route.query.share_id && this.$route.query.source){
            router.push({ name: 'Home' , query:{share_id:this.$route.query.share_id,source:this.$route.query.source}})
          }else{
            router.push({ name: 'Home' })
          }
          window.location.reload()
        }else if(logintype == 2){
          var usercode = localStorage.getItem("BLHusercode");
          if(this.$route.query.share_id && this.$route.query.source){
            router.push({ name: 'Home' , query:{token:usercode,share_id:this.$route.query.share_id,source:this.$route.query.source}})
          }else{
            router.push({ name: 'Home' })
          }
          window.location.reload()
        }else if(logintype == 3){

        }
      }
    },
    mounted () {
      this.loginMode()
    },
  }
</script>

<style lang="less" scoped>
  .login{
    width: 100%;
    min-height: 100vh;
    background-image: url("/static/images/login-bg.png");
    background-size: 100% 100%;
    .van-cell-group{
      padding: 0 20px;
    }
    .login-box{
      padding-top: 15vh;
      padding-bottom: 25%;
      text-align: center;
    }
    .logo{
      width: auto;
      min-width: 120px;
      max-width: 170px;
    }
    .codeimg{
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    .codebox{
      line-height: 35px;
    }
    .codebox .van-button{
      height: 30px;
      line-height: 30px;
      border: none;
    }
    .loginbtn{
      margin-bottom: 15px;
      padding: 0 15px;
      border-radius: 3px;
    }
    .restBox::after{
      border-bottom-width:0;
    }
    .inputlabel{
      vertical-align: middle;
      font-size: 20px;
      margin-right: 15px;
      margin-top: 2px;
    }
    .van-cell__title{
      .iconfont{
        vertical-align: middle;
        font-size: 20px;
        margin-right: 5px;
      }
    }
    .van-field--has-icon{
      border: 1px solid #DBDCDE;
      margin-bottom: 12px;
      background-color: #F5F6FA;
    }
    .van-field__button{
      width: 35%;
      float: right;
      height: 46px;
      .van-button{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/register/index.vue